function yn(n) {
  return n;
}
function un(n, t, e, r, o, f, h, _, M) {
  switch (arguments.length) {
    case 1:
      return n;
    case 2:
      return t(n);
    case 3:
      return e(t(n));
    case 4:
      return r(e(t(n)));
    case 5:
      return o(r(e(t(n))));
    case 6:
      return f(o(r(e(t(n)))));
    case 7:
      return h(f(o(r(e(t(n))))));
    case 8:
      return _(h(f(o(r(e(t(n)))))));
    case 9:
      return M(_(h(f(o(r(e(t(n))))))));
    default: {
      for (var A = arguments[0], F = 1; F < arguments.length; F++)
        A = arguments[F](A);
      return A;
    }
  }
}
globalThis && globalThis.__spreadArray;
var ot = { _tag: "None" }, ct = function(n) {
  return { _tag: "Some", value: n };
}, ft = function(n) {
  return n._tag === "Left";
}, lt = function(n) {
  return { _tag: "Left", left: n };
}, dt = function(n) {
  return { _tag: "Right", right: n };
}, ht = ot, gt = ct, st = function(n) {
  return n._tag === "None";
}, vt = function(n) {
  return function(t) {
    return st(t) ? n() : t.value;
  };
}, mt = vt, yt = function(n) {
  return n == null ? ht : gt(n);
}, Rn = /* @__PURE__ */ ((n) => (n.AE = "auto_equity", n.AF = "auto_fin", n.BE = "benefits", n.CA = "creditas_auto", n.CAC2C = "creditas_auto_c2c", n.CR = "cross", n.HE = "home_equity", n.HF = "home_financing", n.HS = "home_solutions", n.IS = "insurance", n.IN = "institutional", n.MX = "mexico", n.PA = "partnership", n.PAE = "partnership_auto_equity", n.PHE = "partnership_home_equity", n.PHF = "partnership_home_financing", n.PIS = "partnership_insurance", n))(Rn || {});
const _t = (n, t) => {
  const e = {}, r = n[0](t);
  return e.page = r.page, e.identify = r.identify, e.track = r.track, e;
};
var pt = lt, On = dt, _n = function(n) {
  return function(t) {
    return bt(t) ? t : On(n(t.right));
  };
}, bt = ft, pn = function(n) {
  return function(t) {
    return t == null ? pt(n) : On(t);
  };
}, O = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Et(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var an = { exports: {} };
(function(n, t) {
  var e = typeof self < "u" ? self : O, r = function() {
    function f() {
      this.fetch = !1, this.DOMException = e.DOMException;
    }
    return f.prototype = e, new f();
  }();
  (function(f) {
    (function(h) {
      var _ = {
        searchParams: "URLSearchParams" in f,
        iterable: "Symbol" in f && "iterator" in Symbol,
        blob: "FileReader" in f && "Blob" in f && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in f,
        arrayBuffer: "ArrayBuffer" in f
      };
      function M(a) {
        return a && DataView.prototype.isPrototypeOf(a);
      }
      if (_.arrayBuffer)
        var A = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], F = ArrayBuffer.isView || function(a) {
          return a && A.indexOf(Object.prototype.toString.call(a)) > -1;
        };
      function S(a) {
        if (typeof a != "string" && (a = String(a)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(a))
          throw new TypeError("Invalid character in header field name");
        return a.toLowerCase();
      }
      function b(a) {
        return typeof a != "string" && (a = String(a)), a;
      }
      function w(a) {
        var l = {
          next: function() {
            var y = a.shift();
            return { done: y === void 0, value: y };
          }
        };
        return _.iterable && (l[Symbol.iterator] = function() {
          return l;
        }), l;
      }
      function v(a) {
        this.map = {}, a instanceof v ? a.forEach(function(l, y) {
          this.append(y, l);
        }, this) : Array.isArray(a) ? a.forEach(function(l) {
          this.append(l[0], l[1]);
        }, this) : a && Object.getOwnPropertyNames(a).forEach(function(l) {
          this.append(l, a[l]);
        }, this);
      }
      v.prototype.append = function(a, l) {
        a = S(a), l = b(l);
        var y = this.map[a];
        this.map[a] = y ? y + ", " + l : l;
      }, v.prototype.delete = function(a) {
        delete this.map[S(a)];
      }, v.prototype.get = function(a) {
        return a = S(a), this.has(a) ? this.map[a] : null;
      }, v.prototype.has = function(a) {
        return this.map.hasOwnProperty(S(a));
      }, v.prototype.set = function(a, l) {
        this.map[S(a)] = b(l);
      }, v.prototype.forEach = function(a, l) {
        for (var y in this.map)
          this.map.hasOwnProperty(y) && a.call(l, this.map[y], y, this);
      }, v.prototype.keys = function() {
        var a = [];
        return this.forEach(function(l, y) {
          a.push(y);
        }), w(a);
      }, v.prototype.values = function() {
        var a = [];
        return this.forEach(function(l) {
          a.push(l);
        }), w(a);
      }, v.prototype.entries = function() {
        var a = [];
        return this.forEach(function(l, y) {
          a.push([y, l]);
        }), w(a);
      }, _.iterable && (v.prototype[Symbol.iterator] = v.prototype.entries);
      function j(a) {
        if (a.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        a.bodyUsed = !0;
      }
      function B(a) {
        return new Promise(function(l, y) {
          a.onload = function() {
            l(a.result);
          }, a.onerror = function() {
            y(a.error);
          };
        });
      }
      function V(a) {
        var l = new FileReader(), y = B(l);
        return l.readAsArrayBuffer(a), y;
      }
      function K(a) {
        var l = new FileReader(), y = B(l);
        return l.readAsText(a), y;
      }
      function $(a) {
        for (var l = new Uint8Array(a), y = new Array(l.length), N = 0; N < l.length; N++)
          y[N] = String.fromCharCode(l[N]);
        return y.join("");
      }
      function H(a) {
        if (a.slice)
          return a.slice(0);
        var l = new Uint8Array(a.byteLength);
        return l.set(new Uint8Array(a)), l.buffer;
      }
      function d() {
        return this.bodyUsed = !1, this._initBody = function(a) {
          this._bodyInit = a, a ? typeof a == "string" ? this._bodyText = a : _.blob && Blob.prototype.isPrototypeOf(a) ? this._bodyBlob = a : _.formData && FormData.prototype.isPrototypeOf(a) ? this._bodyFormData = a : _.searchParams && URLSearchParams.prototype.isPrototypeOf(a) ? this._bodyText = a.toString() : _.arrayBuffer && _.blob && M(a) ? (this._bodyArrayBuffer = H(a.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : _.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(a) || F(a)) ? this._bodyArrayBuffer = H(a) : this._bodyText = a = Object.prototype.toString.call(a) : this._bodyText = "", this.headers.get("content-type") || (typeof a == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : _.searchParams && URLSearchParams.prototype.isPrototypeOf(a) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, _.blob && (this.blob = function() {
          var a = j(this);
          if (a)
            return a;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? j(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(V);
        }), this.text = function() {
          var a = j(this);
          if (a)
            return a;
          if (this._bodyBlob)
            return K(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve($(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, _.formData && (this.formData = function() {
          return this.text().then(L);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var g = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function m(a) {
        var l = a.toUpperCase();
        return g.indexOf(l) > -1 ? l : a;
      }
      function s(a, l) {
        l = l || {};
        var y = l.body;
        if (a instanceof s) {
          if (a.bodyUsed)
            throw new TypeError("Already read");
          this.url = a.url, this.credentials = a.credentials, l.headers || (this.headers = new v(a.headers)), this.method = a.method, this.mode = a.mode, this.signal = a.signal, !y && a._bodyInit != null && (y = a._bodyInit, a.bodyUsed = !0);
        } else
          this.url = String(a);
        if (this.credentials = l.credentials || this.credentials || "same-origin", (l.headers || !this.headers) && (this.headers = new v(l.headers)), this.method = m(l.method || this.method || "GET"), this.mode = l.mode || this.mode || null, this.signal = l.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && y)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(y);
      }
      s.prototype.clone = function() {
        return new s(this, { body: this._bodyInit });
      };
      function L(a) {
        var l = new FormData();
        return a.trim().split("&").forEach(function(y) {
          if (y) {
            var N = y.split("="), P = N.shift().replace(/\+/g, " "), R = N.join("=").replace(/\+/g, " ");
            l.append(decodeURIComponent(P), decodeURIComponent(R));
          }
        }), l;
      }
      function W(a) {
        var l = new v(), y = a.replace(/\r?\n[\t ]+/g, " ");
        return y.split(/\r?\n/).forEach(function(N) {
          var P = N.split(":"), R = P.shift().trim();
          if (R) {
            var x = P.join(":").trim();
            l.append(R, x);
          }
        }), l;
      }
      d.call(s.prototype);
      function I(a, l) {
        l || (l = {}), this.type = "default", this.status = l.status === void 0 ? 200 : l.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in l ? l.statusText : "OK", this.headers = new v(l.headers), this.url = l.url || "", this._initBody(a);
      }
      d.call(I.prototype), I.prototype.clone = function() {
        return new I(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new v(this.headers),
          url: this.url
        });
      }, I.error = function() {
        var a = new I(null, { status: 0, statusText: "" });
        return a.type = "error", a;
      };
      var G = [301, 302, 303, 307, 308];
      I.redirect = function(a, l) {
        if (G.indexOf(l) === -1)
          throw new RangeError("Invalid status code");
        return new I(null, { status: l, headers: { location: a } });
      }, h.DOMException = f.DOMException;
      try {
        new h.DOMException();
      } catch {
        h.DOMException = function(l, y) {
          this.message = l, this.name = y;
          var N = Error(l);
          this.stack = N.stack;
        }, h.DOMException.prototype = Object.create(Error.prototype), h.DOMException.prototype.constructor = h.DOMException;
      }
      function J(a, l) {
        return new Promise(function(y, N) {
          var P = new s(a, l);
          if (P.signal && P.signal.aborted)
            return N(new h.DOMException("Aborted", "AbortError"));
          var R = new XMLHttpRequest();
          function x() {
            R.abort();
          }
          R.onload = function() {
            var X = {
              status: R.status,
              statusText: R.statusText,
              headers: W(R.getAllResponseHeaders() || "")
            };
            X.url = "responseURL" in R ? R.responseURL : X.headers.get("X-Request-URL");
            var en = "response" in R ? R.response : R.responseText;
            y(new I(en, X));
          }, R.onerror = function() {
            N(new TypeError("Network request failed"));
          }, R.ontimeout = function() {
            N(new TypeError("Network request failed"));
          }, R.onabort = function() {
            N(new h.DOMException("Aborted", "AbortError"));
          }, R.open(P.method, P.url, !0), P.credentials === "include" ? R.withCredentials = !0 : P.credentials === "omit" && (R.withCredentials = !1), "responseType" in R && _.blob && (R.responseType = "blob"), P.headers.forEach(function(X, en) {
            R.setRequestHeader(en, X);
          }), P.signal && (P.signal.addEventListener("abort", x), R.onreadystatechange = function() {
            R.readyState === 4 && P.signal.removeEventListener("abort", x);
          }), R.send(typeof P._bodyInit > "u" ? null : P._bodyInit);
        });
      }
      return J.polyfill = !0, f.fetch || (f.fetch = J, f.Headers = v, f.Request = s, f.Response = I), h.Headers = v, h.Request = s, h.Response = I, h.fetch = J, Object.defineProperty(h, "__esModule", { value: !0 }), h;
    })({});
  })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
  var o = r;
  t = o.fetch, t.default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, n.exports = t;
})(an, an.exports);
const At = /* @__PURE__ */ Et(an.exports), Rt = async ({ email: n, userDocumentId: t, cellphone: e }, r) => new Promise((o) => {
  const f = t && { userDocumentId: t }, h = n && { email: n }, _ = e && { cellphone: e }, M = JSON.stringify({
    query: `query CreateStitchingUserId($email: String, $userDocumentId: String, $cellphone: String) {
      createStitchingUserId(email: $email, userDocumentId: $userDocumentId, cellphone: $cellphone) {
        data {
          contactId
        }
      }
    }`,
    variables: {
      ...f,
      ...h,
      ..._
    }
  }), A = new an.exports.Headers({
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  let F = "https://api.creditas.io/customer-data-platform-bff/graphql";
  r.environment !== "production" && (F = "https://stg-api.creditas.io/customer-data-platform-bff/graphql"), At(new an.exports.Request(F), {
    method: "POST",
    body: M,
    headers: A
  }).then((S) => {
    if (S.status === 200)
      return S.json();
    throw new Error(
      "Bad response from server event-track customer-data-platform-bff"
    );
  }).then((S) => {
    var b;
    ((b = S == null ? void 0 : S.errors) == null ? void 0 : b.length) > 0 && o(null), o(S.data.createStitchingUserId.data.contactId);
  });
});
function hn(n) {
  return String(n).replace(/[^\d]/g, "");
}
function Ot(n, t) {
  var e = hn(n), r = typeof t == "number" ? Array(e.length).fill(0).map(function(o, f) {
    return t - f;
  }) : t;
  return e.split("").reduce(function(o, f, h) {
    return o + parseInt(f, 10) * r[h];
  }, 0);
}
var bn = {
  AC: {
    code: "2",
    areaCodes: [68],
    ieLength: 13,
    name: "Acre"
  },
  AL: {
    code: "4",
    areaCodes: [82],
    ieLength: 9,
    name: "Alagoas"
  },
  AP: {
    code: "2",
    areaCodes: [96],
    ieLength: 9,
    name: "Amap\xE1"
  },
  AM: {
    code: "2",
    areaCodes: [92, 97],
    ieLength: 9,
    name: "Amazonas"
  },
  BA: {
    code: "5",
    areaCodes: [71, 73, 74, 75, 77],
    ieLength: [8, 9],
    name: "Bahia"
  },
  CE: {
    code: "3",
    areaCodes: [85, 88],
    ieLength: 9,
    name: "Cear\xE1"
  },
  DF: {
    code: "1",
    areaCodes: [61],
    ieLength: 13,
    name: "Distrito Federal"
  },
  ES: {
    code: "7",
    areaCodes: [27, 28],
    ieLength: 9,
    name: "Esp\xEDrito Santo"
  },
  GO: {
    code: "1",
    areaCodes: [62, 64],
    ieLength: 9,
    name: "Goi\xE1s"
  },
  MA: {
    code: "3",
    areaCodes: [98, 99],
    ieLength: 9,
    name: "Maranh\xE3o"
  },
  MG: {
    code: "6",
    areaCodes: [31, 32, 33, 34, 35, 37, 38],
    ieLength: 13,
    name: "Minas Gerais"
  },
  MT: {
    code: "1",
    areaCodes: [65, 66],
    ieLength: 11,
    name: "Mato Grosso"
  },
  MS: {
    code: "1",
    areaCodes: [67],
    ieLength: 9,
    name: "Mato Grosso do Sul"
  },
  PA: {
    code: "2",
    areaCodes: [91, 93, 94],
    ieLength: 9,
    name: "Par\xE1"
  },
  PB: {
    code: "4",
    areaCodes: [83],
    ieLength: 9,
    name: "Para\xEDba"
  },
  PE: {
    code: "4",
    areaCodes: [81, 87],
    ieLength: 9,
    name: "Pernambuco"
  },
  PI: {
    code: "3",
    areaCodes: [86, 89],
    ieLength: 9,
    name: "Piau\xED"
  },
  PR: {
    code: "9",
    areaCodes: [41, 42, 43, 44, 45, 46],
    ieLength: 10,
    name: "Paran\xE1"
  },
  RJ: {
    code: "7",
    areaCodes: [21, 22, 24],
    ieLength: 8,
    name: "Rio de Janeiro"
  },
  RN: {
    code: "4",
    areaCodes: [84],
    ieLength: [9, 10],
    name: "Rio Grande do Norte"
  },
  RO: {
    code: "2",
    areaCodes: [69],
    ieLength: 14,
    name: "Rond\xF4nia"
  },
  RS: {
    code: "0",
    areaCodes: [51, 53, 54, 55],
    ieLength: 10,
    name: "Rio Grande do Sul"
  },
  RR: {
    code: "2",
    areaCodes: [95],
    ieLength: 9,
    name: "Roraima"
  },
  SC: {
    code: "9",
    areaCodes: [47, 48, 49],
    ieLength: 9,
    name: "Santa Catarina"
  },
  SE: {
    code: "5",
    areaCodes: [79],
    ieLength: 9,
    name: "Sergipe"
  },
  SP: {
    code: "8",
    areaCodes: [11, 12, 13, 14, 15, 16, 17, 18, 19],
    ieLength: 12,
    name: "S\xE3o Paulo"
  },
  TO: {
    code: "1",
    areaCodes: [63],
    ieLength: [9, 11],
    name: "Tocantins"
  }
}, St = /* @__PURE__ */ Object.keys(bn).reduce(function(n, t) {
  return n.concat(bn[t].areaCodes);
}, []), Sn = 10, wn = 11, wt = [6, 7, 8, 9], Lt = [2, 3, 4, 5];
function It(n) {
  return St.includes(Number(n.substr(0, 2)));
}
function Ct(n) {
  return n.length === wn;
}
function Mt(n) {
  return n.length >= Sn && n.length < wn;
}
function Pt(n) {
  return Mt(n) || Ct(n);
}
function Nt(n) {
  return wt.includes(Number(n.charAt(2)));
}
function Tt(n) {
  return Lt.includes(Number(n.charAt(2)));
}
function Dt(n) {
  return n.length === Sn ? Tt(n) : Nt(n);
}
function Ft(n) {
  return {
    isValidDigits: !!n && typeof n == "string",
    digits: hn(n)
  };
}
function Ut(n) {
  var t = Ft(n), e = t.isValidDigits, r = t.digits;
  return e ? Pt(r) && Dt(r) && It(r) : !1;
}
var Ln = 64, In = 253, jt = Ln + 1 + In, Wt = /^([!#$%&'*+\-/=?^_`{|}~]{0,1}([a-zA-Z0-9][!#$%&'*+\-/=?^_`{|}~.]{0,1})+)@(([a-zA-Z0-9][-.]{0,1})+)([.]{1}[a-zA-Z0-9]+)$/, cn = function(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)
    r[o - 1] = arguments[o];
  return r.reduce(function(f, h) {
    return f + h.length;
  }, 0) > t;
};
function qt(n) {
  if (!n || typeof n != "string" || cn(jt, n))
    return !1;
  var t = Wt.exec(n);
  if (!t)
    return !1;
  var e = t[1], r = t[3], o = t[5];
  return !(cn(Ln, e) || cn(In, r, o));
}
var Bt = ["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"], Vt = [9, 10];
function Kt(n) {
  return /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(n);
}
function $t(n) {
  return Bt.indexOf(n) >= 0;
}
function Ht(n) {
  return Vt.every(function(t) {
    var e = Ot(n.slice(0, t).split("").reduce(function(r, o) {
      return r + o;
    }, ""), t + 1) % 11;
    return n[t] === String(e < 2 ? 0 : 11 - e);
  });
}
function Gt(n) {
  if (!n || typeof n != "string")
    return !1;
  var t = hn(n);
  return Kt(n) && !$t(t) && Ht(t);
}
const En = (n) => n.replace(/\W/g, ""), Jt = (n) => {
  const t = Object.entries(n).map(([e, r]) => {
    const o = String(r);
    return Gt(o) ? ["userDocumentId", En(o)] : Ut(o) ? ["cellphone", En(o)] : qt(o) ? ["email", r] : [e, r];
  });
  return Object.fromEntries(t);
}, zt = async (n, t, e) => {
  const r = [...t];
  if (typeof t[0] == "string" && r.splice(0, 1), typeof r[0] == "object") {
    const o = Jt(r[0]), h = { ...Ye(), ...o };
    if (!!h.userDocumentId || !!h.email || !!h.cellphone) {
      const _ = await Rt(h, e);
      if (_)
        return n.identify(_, { ...h, ...r[0] });
    }
    return n.identify(r[0]);
  }
};
function Xt(n) {
  return {
    name: "segment-plugin",
    page: (...t) => {
      un(
        window.analytics,
        pn("nully"),
        _n((e) => {
          e.page(...t);
        })
      );
    },
    track: (...t) => {
      t[1] = { ...n, ...t[1] }, un(
        window.analytics,
        pn("nully"),
        _n((e) => {
          e.track(...t);
        })
      );
    },
    identify: async (...t) => {
      if (window.analytics)
        return await zt(window.analytics, t, n);
    }
  };
}
const Ze = ({
  bu: n,
  application: t,
  environment: e,
  plugins: r,
  ...o
}) => {
  const f = un(
    r,
    yt,
    mt(() => [Xt])
  ), h = {
    bu: Rn[n],
    application: t,
    environment: e,
    ...o
  };
  return _t(f, h);
};
var ln = {}, tn = {}, D = {}, k = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.getEndomorphismMonoid = n.not = n.SK = n.hole = n.pipe = n.untupled = n.tupled = n.absurd = n.decrement = n.increment = n.tuple = n.flow = n.flip = n.constVoid = n.constUndefined = n.constNull = n.constFalse = n.constTrue = n.constant = n.unsafeCoerce = n.identity = n.apply = n.getRing = n.getSemiring = n.getMonoid = n.getSemigroup = n.getBooleanAlgebra = void 0;
  var t = function(d) {
    return function() {
      return {
        meet: function(g, m) {
          return function(s) {
            return d.meet(g(s), m(s));
          };
        },
        join: function(g, m) {
          return function(s) {
            return d.join(g(s), m(s));
          };
        },
        zero: function() {
          return d.zero;
        },
        one: function() {
          return d.one;
        },
        implies: function(g, m) {
          return function(s) {
            return d.implies(g(s), m(s));
          };
        },
        not: function(g) {
          return function(m) {
            return d.not(g(m));
          };
        }
      };
    };
  };
  n.getBooleanAlgebra = t;
  var e = function(d) {
    return function() {
      return {
        concat: function(g, m) {
          return function(s) {
            return d.concat(g(s), m(s));
          };
        }
      };
    };
  };
  n.getSemigroup = e;
  var r = function(d) {
    var g = (0, n.getSemigroup)(d);
    return function() {
      return {
        concat: g().concat,
        empty: function() {
          return d.empty;
        }
      };
    };
  };
  n.getMonoid = r;
  var o = function(d) {
    return {
      add: function(g, m) {
        return function(s) {
          return d.add(g(s), m(s));
        };
      },
      zero: function() {
        return d.zero;
      },
      mul: function(g, m) {
        return function(s) {
          return d.mul(g(s), m(s));
        };
      },
      one: function() {
        return d.one;
      }
    };
  };
  n.getSemiring = o;
  var f = function(d) {
    var g = (0, n.getSemiring)(d);
    return {
      add: g.add,
      mul: g.mul,
      one: g.one,
      zero: g.zero,
      sub: function(m, s) {
        return function(L) {
          return d.sub(m(L), s(L));
        };
      }
    };
  };
  n.getRing = f;
  var h = function(d) {
    return function(g) {
      return g(d);
    };
  };
  n.apply = h;
  function _(d) {
    return d;
  }
  n.identity = _, n.unsafeCoerce = _;
  function M(d) {
    return function() {
      return d;
    };
  }
  n.constant = M, n.constTrue = M(!0), n.constFalse = M(!1), n.constNull = M(null), n.constUndefined = M(void 0), n.constVoid = n.constUndefined;
  function A(d) {
    return function(g, m) {
      return d(m, g);
    };
  }
  n.flip = A;
  function F(d, g, m, s, L, W, I, G, J) {
    switch (arguments.length) {
      case 1:
        return d;
      case 2:
        return function() {
          return g(d.apply(this, arguments));
        };
      case 3:
        return function() {
          return m(g(d.apply(this, arguments)));
        };
      case 4:
        return function() {
          return s(m(g(d.apply(this, arguments))));
        };
      case 5:
        return function() {
          return L(s(m(g(d.apply(this, arguments)))));
        };
      case 6:
        return function() {
          return W(L(s(m(g(d.apply(this, arguments))))));
        };
      case 7:
        return function() {
          return I(W(L(s(m(g(d.apply(this, arguments)))))));
        };
      case 8:
        return function() {
          return G(I(W(L(s(m(g(d.apply(this, arguments))))))));
        };
      case 9:
        return function() {
          return J(G(I(W(L(s(m(g(d.apply(this, arguments)))))))));
        };
    }
  }
  n.flow = F;
  function S() {
    for (var d = [], g = 0; g < arguments.length; g++)
      d[g] = arguments[g];
    return d;
  }
  n.tuple = S;
  function b(d) {
    return d + 1;
  }
  n.increment = b;
  function w(d) {
    return d - 1;
  }
  n.decrement = w;
  function v(d) {
    throw new Error("Called `absurd` function which should be uncallable");
  }
  n.absurd = v;
  function j(d) {
    return function(g) {
      return d.apply(void 0, g);
    };
  }
  n.tupled = j;
  function B(d) {
    return function() {
      for (var g = [], m = 0; m < arguments.length; m++)
        g[m] = arguments[m];
      return d(g);
    };
  }
  n.untupled = B;
  function V(d, g, m, s, L, W, I, G, J) {
    switch (arguments.length) {
      case 1:
        return d;
      case 2:
        return g(d);
      case 3:
        return m(g(d));
      case 4:
        return s(m(g(d)));
      case 5:
        return L(s(m(g(d))));
      case 6:
        return W(L(s(m(g(d)))));
      case 7:
        return I(W(L(s(m(g(d))))));
      case 8:
        return G(I(W(L(s(m(g(d)))))));
      case 9:
        return J(G(I(W(L(s(m(g(d))))))));
      default: {
        for (var a = arguments[0], l = 1; l < arguments.length; l++)
          a = arguments[l](a);
        return a;
      }
    }
  }
  n.pipe = V, n.hole = v;
  var K = function(d, g) {
    return g;
  };
  n.SK = K;
  function $(d) {
    return function(g) {
      return !d(g);
    };
  }
  n.not = $;
  var H = function() {
    return {
      concat: function(d, g) {
        return F(d, g);
      },
      empty: _
    };
  };
  n.getEndomorphismMonoid = H;
})(k);
var p = {}, Yt = O && O.__spreadArray || function(n, t, e) {
  if (e || arguments.length === 2)
    for (var r = 0, o = t.length, f; r < o; r++)
      (f || !(r in t)) && (f || (f = Array.prototype.slice.call(t, 0, r)), f[r] = t[r]);
  return n.concat(f || Array.prototype.slice.call(t));
};
Object.defineProperty(p, "__esModule", { value: !0 });
p.fromReadonlyNonEmptyArray = p.has = p.emptyRecord = p.emptyReadonlyArray = p.tail = p.head = p.isNonEmpty = p.singleton = p.right = p.left = p.isRight = p.isLeft = p.some = p.none = p.isSome = p.isNone = void 0;
var Zt = function(n) {
  return n._tag === "None";
};
p.isNone = Zt;
var Qt = function(n) {
  return n._tag === "Some";
};
p.isSome = Qt;
p.none = { _tag: "None" };
var kt = function(n) {
  return { _tag: "Some", value: n };
};
p.some = kt;
var xt = function(n) {
  return n._tag === "Left";
};
p.isLeft = xt;
var ne = function(n) {
  return n._tag === "Right";
};
p.isRight = ne;
var te = function(n) {
  return { _tag: "Left", left: n };
};
p.left = te;
var ee = function(n) {
  return { _tag: "Right", right: n };
};
p.right = ee;
var re = function(n) {
  return [n];
};
p.singleton = re;
var ie = function(n) {
  return n.length > 0;
};
p.isNonEmpty = ie;
var ae = function(n) {
  return n[0];
};
p.head = ae;
var ue = function(n) {
  return n.slice(1);
};
p.tail = ue;
p.emptyReadonlyArray = [];
p.emptyRecord = {};
p.has = Object.prototype.hasOwnProperty;
var oe = function(n) {
  return Yt([n[0]], n.slice(1), !0);
};
p.fromReadonlyNonEmptyArray = oe;
var ce = O && O.__createBinding || (Object.create ? function(n, t, e, r) {
  r === void 0 && (r = e);
  var o = Object.getOwnPropertyDescriptor(t, e);
  (!o || ("get" in o ? !t.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return t[e];
  } }), Object.defineProperty(n, r, o);
} : function(n, t, e, r) {
  r === void 0 && (r = e), n[r] = t[e];
}), fe = O && O.__setModuleDefault || (Object.create ? function(n, t) {
  Object.defineProperty(n, "default", { enumerable: !0, value: t });
} : function(n, t) {
  n.default = t;
}), le = O && O.__importStar || function(n) {
  if (n && n.__esModule)
    return n;
  var t = {};
  if (n != null)
    for (var e in n)
      e !== "default" && Object.prototype.hasOwnProperty.call(n, e) && ce(t, n, e);
  return fe(t, n), t;
};
Object.defineProperty(D, "__esModule", { value: !0 });
D.sequenceS = D.sequenceT = D.getApplySemigroup = D.apS = D.apSecond = D.apFirst = D.ap = void 0;
var de = k, he = le(p);
function ge(n, t) {
  return function(e) {
    return function(r) {
      return n.ap(n.map(r, function(o) {
        return function(f) {
          return t.ap(o, f);
        };
      }), e);
    };
  };
}
D.ap = ge;
function se(n) {
  return function(t) {
    return function(e) {
      return n.ap(n.map(e, function(r) {
        return function() {
          return r;
        };
      }), t);
    };
  };
}
D.apFirst = se;
function ve(n) {
  return function(t) {
    return function(e) {
      return n.ap(n.map(e, function() {
        return function(r) {
          return r;
        };
      }), t);
    };
  };
}
D.apSecond = ve;
function me(n) {
  return function(t, e) {
    return function(r) {
      return n.ap(n.map(r, function(o) {
        return function(f) {
          var h;
          return Object.assign({}, o, (h = {}, h[t] = f, h));
        };
      }), e);
    };
  };
}
D.apS = me;
function ye(n) {
  return function(t) {
    return {
      concat: function(e, r) {
        return n.ap(n.map(e, function(o) {
          return function(f) {
            return t.concat(o, f);
          };
        }), r);
      }
    };
  };
}
D.getApplySemigroup = ye;
function gn(n, t, e) {
  return function(r) {
    for (var o = Array(e.length + 1), f = 0; f < e.length; f++)
      o[f] = e[f];
    return o[e.length] = r, t === 0 ? n.apply(null, o) : gn(n, t - 1, o);
  };
}
var fn = {
  1: function(n) {
    return [n];
  },
  2: function(n) {
    return function(t) {
      return [n, t];
    };
  },
  3: function(n) {
    return function(t) {
      return function(e) {
        return [n, t, e];
      };
    };
  },
  4: function(n) {
    return function(t) {
      return function(e) {
        return function(r) {
          return [n, t, e, r];
        };
      };
    };
  },
  5: function(n) {
    return function(t) {
      return function(e) {
        return function(r) {
          return function(o) {
            return [n, t, e, r, o];
          };
        };
      };
    };
  }
};
function _e(n) {
  return he.has.call(fn, n) || (fn[n] = gn(de.tuple, n - 1, [])), fn[n];
}
function pe(n) {
  return function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    for (var r = t.length, o = _e(r), f = n.map(t[0], o), h = 1; h < r; h++)
      f = n.ap(f, t[h]);
    return f;
  };
}
D.sequenceT = pe;
function be(n) {
  var t = n.length;
  switch (t) {
    case 1:
      return function(e) {
        var r;
        return r = {}, r[n[0]] = e, r;
      };
    case 2:
      return function(e) {
        return function(r) {
          var o;
          return o = {}, o[n[0]] = e, o[n[1]] = r, o;
        };
      };
    case 3:
      return function(e) {
        return function(r) {
          return function(o) {
            var f;
            return f = {}, f[n[0]] = e, f[n[1]] = r, f[n[2]] = o, f;
          };
        };
      };
    case 4:
      return function(e) {
        return function(r) {
          return function(o) {
            return function(f) {
              var h;
              return h = {}, h[n[0]] = e, h[n[1]] = r, h[n[2]] = o, h[n[3]] = f, h;
            };
          };
        };
      };
    case 5:
      return function(e) {
        return function(r) {
          return function(o) {
            return function(f) {
              return function(h) {
                var _;
                return _ = {}, _[n[0]] = e, _[n[1]] = r, _[n[2]] = o, _[n[3]] = f, _[n[4]] = h, _;
              };
            };
          };
        };
      };
    default:
      return gn(function() {
        for (var e = [], r = 0; r < arguments.length; r++)
          e[r] = arguments[r];
        for (var o = {}, f = 0; f < t; f++)
          o[n[f]] = e[f];
        return o;
      }, t - 1, []);
  }
}
function Ee(n) {
  return function(t) {
    for (var e = Object.keys(t), r = e.length, o = be(e), f = n.map(t[e[0]], o), h = 1; h < r; h++)
      f = n.ap(f, t[e[h]]);
    return f;
  };
}
D.sequenceS = Ee;
var q = {};
Object.defineProperty(q, "__esModule", { value: !0 });
q.getFunctorComposition = q.bindTo = q.flap = q.map = void 0;
var Ae = k;
function Cn(n, t) {
  return function(e) {
    return function(r) {
      return n.map(r, function(o) {
        return t.map(o, e);
      });
    };
  };
}
q.map = Cn;
function Re(n) {
  return function(t) {
    return function(e) {
      return n.map(e, function(r) {
        return r(t);
      });
    };
  };
}
q.flap = Re;
function Oe(n) {
  return function(t) {
    return function(e) {
      return n.map(e, function(r) {
        var o;
        return o = {}, o[t] = r, o;
      });
    };
  };
}
q.bindTo = Oe;
function Se(n, t) {
  var e = Cn(n, t);
  return {
    map: function(r, o) {
      return (0, Ae.pipe)(r, e(o));
    }
  };
}
q.getFunctorComposition = Se;
Object.defineProperty(tn, "__esModule", { value: !0 });
tn.getApplicativeComposition = tn.getApplicativeMonoid = void 0;
var Mn = D, we = k, Le = q;
function Ie(n) {
  var t = (0, Mn.getApplySemigroup)(n);
  return function(e) {
    return {
      concat: t(e).concat,
      empty: n.of(e.empty)
    };
  };
}
tn.getApplicativeMonoid = Ie;
function Ce(n, t) {
  var e = (0, Le.getFunctorComposition)(n, t).map, r = (0, Mn.ap)(n, t);
  return {
    map: e,
    of: function(o) {
      return n.of(t.of(o));
    },
    ap: function(o, f) {
      return (0, we.pipe)(o, r(f));
    }
  };
}
tn.getApplicativeComposition = Ce;
var Q = {};
Object.defineProperty(Q, "__esModule", { value: !0 });
Q.bind = Q.chainFirst = void 0;
function Me(n) {
  return function(t) {
    return function(e) {
      return n.chain(e, function(r) {
        return n.map(t(r), function() {
          return r;
        });
      });
    };
  };
}
Q.chainFirst = Me;
function Pe(n) {
  return function(t, e) {
    return function(r) {
      return n.chain(r, function(o) {
        return n.map(e(o), function(f) {
          var h;
          return Object.assign({}, o, (h = {}, h[t] = f, h));
        });
      });
    };
  };
}
Q.bind = Pe;
var on = {};
Object.defineProperty(on, "__esModule", { value: !0 });
on.tailRec = void 0;
var Ne = function(n, t) {
  for (var e = t(n); e._tag === "Left"; )
    e = t(e.left);
  return e.right;
};
on.tailRec = Ne;
var T = {}, Te = O && O.__createBinding || (Object.create ? function(n, t, e, r) {
  r === void 0 && (r = e);
  var o = Object.getOwnPropertyDescriptor(t, e);
  (!o || ("get" in o ? !t.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return t[e];
  } }), Object.defineProperty(n, r, o);
} : function(n, t, e, r) {
  r === void 0 && (r = e), n[r] = t[e];
}), De = O && O.__setModuleDefault || (Object.create ? function(n, t) {
  Object.defineProperty(n, "default", { enumerable: !0, value: t });
} : function(n, t) {
  n.default = t;
}), Fe = O && O.__importStar || function(n) {
  if (n && n.__esModule)
    return n;
  var t = {};
  if (n != null)
    for (var e in n)
      e !== "default" && Object.prototype.hasOwnProperty.call(n, e) && Te(t, n, e);
  return De(t, n), t;
};
Object.defineProperty(T, "__esModule", { value: !0 });
T.filterOrElse = T.chainFirstEitherK = T.chainEitherK = T.fromEitherK = T.chainOptionK = T.fromOptionK = T.fromPredicate = T.fromOption = void 0;
var Ue = Q, sn = k, Z = Fe(p);
function Pn(n) {
  return function(t) {
    return function(e) {
      return n.fromEither(Z.isNone(e) ? Z.left(t()) : Z.right(e.value));
    };
  };
}
T.fromOption = Pn;
function je(n) {
  return function(t, e) {
    return function(r) {
      return n.fromEither(t(r) ? Z.right(r) : Z.left(e(r)));
    };
  };
}
T.fromPredicate = je;
function Nn(n) {
  var t = Pn(n);
  return function(e) {
    var r = t(e);
    return function(o) {
      return (0, sn.flow)(o, r);
    };
  };
}
T.fromOptionK = Nn;
function We(n, t) {
  var e = Nn(n);
  return function(r) {
    var o = e(r);
    return function(f) {
      return function(h) {
        return t.chain(h, o(f));
      };
    };
  };
}
T.chainOptionK = We;
function vn(n) {
  return function(t) {
    return (0, sn.flow)(t, n.fromEither);
  };
}
T.fromEitherK = vn;
function qe(n, t) {
  var e = vn(n);
  return function(r) {
    return function(o) {
      return t.chain(o, e(r));
    };
  };
}
T.chainEitherK = qe;
function Be(n, t) {
  return (0, sn.flow)(vn(n), (0, Ue.chainFirst)(t));
}
T.chainFirstEitherK = Be;
function Ve(n, t) {
  return function(e, r) {
    return function(o) {
      return t.chain(o, function(f) {
        return n.fromEither(e(f) ? Z.right(f) : Z.left(r(f)));
      });
    };
  };
}
T.filterOrElse = Ve;
var Tn = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.right = n.left = n.flap = n.Functor = n.Bifunctor = n.URI = n.bimap = n.mapLeft = n.map = n.separated = void 0;
  var t = k, e = q, r = function(b, w) {
    return { left: b, right: w };
  };
  n.separated = r;
  var o = function(b, w) {
    return (0, t.pipe)(b, (0, n.map)(w));
  }, f = function(b, w) {
    return (0, t.pipe)(b, (0, n.mapLeft)(w));
  }, h = function(b, w, v) {
    return (0, t.pipe)(b, (0, n.bimap)(w, v));
  }, _ = function(b) {
    return function(w) {
      return (0, n.separated)((0, n.left)(w), b((0, n.right)(w)));
    };
  };
  n.map = _;
  var M = function(b) {
    return function(w) {
      return (0, n.separated)(b((0, n.left)(w)), (0, n.right)(w));
    };
  };
  n.mapLeft = M;
  var A = function(b, w) {
    return function(v) {
      return (0, n.separated)(b((0, n.left)(v)), w((0, n.right)(v)));
    };
  };
  n.bimap = A, n.URI = "Separated", n.Bifunctor = {
    URI: n.URI,
    mapLeft: f,
    bimap: h
  }, n.Functor = {
    URI: n.URI,
    map: o
  }, n.flap = (0, e.flap)(n.Functor);
  var F = function(b) {
    return b.left;
  };
  n.left = F;
  var S = function(b) {
    return b.right;
  };
  n.right = S;
})(Tn);
var z = {}, Ke = O && O.__createBinding || (Object.create ? function(n, t, e, r) {
  r === void 0 && (r = e);
  var o = Object.getOwnPropertyDescriptor(t, e);
  (!o || ("get" in o ? !t.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return t[e];
  } }), Object.defineProperty(n, r, o);
} : function(n, t, e, r) {
  r === void 0 && (r = e), n[r] = t[e];
}), $e = O && O.__setModuleDefault || (Object.create ? function(n, t) {
  Object.defineProperty(n, "default", { enumerable: !0, value: t });
} : function(n, t) {
  n.default = t;
}), He = O && O.__importStar || function(n) {
  if (n && n.__esModule)
    return n;
  var t = {};
  if (n != null)
    for (var e in n)
      e !== "default" && Object.prototype.hasOwnProperty.call(n, e) && Ke(t, n, e);
  return $e(t, n), t;
};
Object.defineProperty(z, "__esModule", { value: !0 });
z.filterE = z.witherDefault = z.wiltDefault = void 0;
var An = He(p);
function Ge(n, t) {
  return function(e) {
    var r = n.traverse(e);
    return function(o, f) {
      return e.map(r(o, f), t.separate);
    };
  };
}
z.wiltDefault = Ge;
function Je(n, t) {
  return function(e) {
    var r = n.traverse(e);
    return function(o, f) {
      return e.map(r(o, f), t.compact);
    };
  };
}
z.witherDefault = Je;
function ze(n) {
  return function(t) {
    var e = n.wither(t);
    return function(r) {
      return function(o) {
        return e(o, function(f) {
          return t.map(r(f), function(h) {
            return h ? An.some(f) : An.none;
          });
        });
      };
    };
  };
}
z.filterE = ze;
(function(n) {
  var t = O && O.__createBinding || (Object.create ? function(u, i, c, E) {
    E === void 0 && (E = c);
    var U = Object.getOwnPropertyDescriptor(i, c);
    (!U || ("get" in U ? !i.__esModule : U.writable || U.configurable)) && (U = { enumerable: !0, get: function() {
      return i[c];
    } }), Object.defineProperty(u, E, U);
  } : function(u, i, c, E) {
    E === void 0 && (E = c), u[E] = i[c];
  }), e = O && O.__setModuleDefault || (Object.create ? function(u, i) {
    Object.defineProperty(u, "default", { enumerable: !0, value: i });
  } : function(u, i) {
    u.default = i;
  }), r = O && O.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var i = {};
    if (u != null)
      for (var c in u)
        c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && t(i, u, c);
    return e(i, u), i;
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.fold = n.match = n.foldW = n.matchW = n.isRight = n.isLeft = n.fromOption = n.fromPredicate = n.FromEither = n.MonadThrow = n.throwError = n.ChainRec = n.Extend = n.extend = n.Alt = n.alt = n.altW = n.Bifunctor = n.mapLeft = n.bimap = n.Traversable = n.sequence = n.traverse = n.Foldable = n.reduceRight = n.foldMap = n.reduce = n.Monad = n.Chain = n.chain = n.chainW = n.Applicative = n.Apply = n.ap = n.apW = n.Pointed = n.of = n.Functor = n.map = n.getAltValidation = n.getApplicativeValidation = n.getWitherable = n.getFilterable = n.getCompactable = n.getSemigroup = n.getEq = n.getShow = n.URI = n.right = n.left = void 0, n.getValidation = n.getValidationMonoid = n.getValidationSemigroup = n.getApplyMonoid = n.getApplySemigroup = n.either = n.stringifyJSON = n.parseJSON = n.sequenceArray = n.traverseArray = n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex = n.traverseReadonlyNonEmptyArrayWithIndex = n.ApT = n.apSW = n.apS = n.bindW = n.bind = n.bindTo = n.Do = n.exists = n.elem = n.toError = n.toUnion = n.chainNullableK = n.fromNullableK = n.tryCatchK = n.tryCatch = n.fromNullable = n.orElse = n.orElseW = n.swap = n.filterOrElseW = n.filterOrElse = n.chainOptionK = n.fromOptionK = n.duplicate = n.flatten = n.flattenW = n.chainFirstW = n.chainFirst = n.apSecondW = n.apSecond = n.apFirstW = n.apFirst = n.flap = n.getOrElse = n.getOrElseW = void 0;
  var o = tn, f = D, h = Q, _ = on, M = T, A = k, F = q, S = r(p), b = Tn, w = z;
  n.left = S.left, n.right = S.right;
  var v = function(u, i) {
    return (0, A.pipe)(u, (0, n.map)(i));
  }, j = function(u, i) {
    return (0, A.pipe)(u, (0, n.ap)(i));
  }, B = function(u, i) {
    return (0, A.pipe)(u, (0, n.chain)(i));
  }, V = function(u, i, c) {
    return (0, A.pipe)(u, (0, n.reduce)(i, c));
  }, K = function(u) {
    return function(i, c) {
      var E = (0, n.foldMap)(u);
      return (0, A.pipe)(i, E(c));
    };
  }, $ = function(u, i, c) {
    return (0, A.pipe)(u, (0, n.reduceRight)(i, c));
  }, H = function(u) {
    var i = (0, n.traverse)(u);
    return function(c, E) {
      return (0, A.pipe)(c, i(E));
    };
  }, d = function(u, i, c) {
    return (0, A.pipe)(u, (0, n.bimap)(i, c));
  }, g = function(u, i) {
    return (0, A.pipe)(u, (0, n.mapLeft)(i));
  }, m = function(u, i) {
    return (0, A.pipe)(u, (0, n.alt)(i));
  }, s = function(u, i) {
    return (0, A.pipe)(u, (0, n.extend)(i));
  }, L = function(u, i) {
    return (0, _.tailRec)(i(u), function(c) {
      return (0, n.isLeft)(c) ? (0, n.right)((0, n.left)(c.left)) : (0, n.isLeft)(c.right) ? (0, n.left)(i(c.right.left)) : (0, n.right)((0, n.right)(c.right.right));
    });
  };
  n.URI = "Either";
  var W = function(u, i) {
    return {
      show: function(c) {
        return (0, n.isLeft)(c) ? "left(".concat(u.show(c.left), ")") : "right(".concat(i.show(c.right), ")");
      }
    };
  };
  n.getShow = W;
  var I = function(u, i) {
    return {
      equals: function(c, E) {
        return c === E || ((0, n.isLeft)(c) ? (0, n.isLeft)(E) && u.equals(c.left, E.left) : (0, n.isRight)(E) && i.equals(c.right, E.right));
      }
    };
  };
  n.getEq = I;
  var G = function(u) {
    return {
      concat: function(i, c) {
        return (0, n.isLeft)(c) ? i : (0, n.isLeft)(i) ? c : (0, n.right)(u.concat(i.right, c.right));
      }
    };
  };
  n.getSemigroup = G;
  var J = function(u) {
    var i = (0, n.left)(u.empty);
    return {
      URI: n.URI,
      _E: void 0,
      compact: function(c) {
        return (0, n.isLeft)(c) ? c : c.right._tag === "None" ? i : (0, n.right)(c.right.value);
      },
      separate: function(c) {
        return (0, n.isLeft)(c) ? (0, b.separated)(c, c) : (0, n.isLeft)(c.right) ? (0, b.separated)((0, n.right)(c.right.left), i) : (0, b.separated)(i, (0, n.right)(c.right.right));
      }
    };
  };
  n.getCompactable = J;
  var a = function(u) {
    var i = (0, n.left)(u.empty), c = (0, n.getCompactable)(u), E = c.compact, U = c.separate, rn = function(C, Y) {
      return (0, n.isLeft)(C) || Y(C.right) ? C : i;
    }, ut = function(C, Y) {
      return (0, n.isLeft)(C) ? (0, b.separated)(C, C) : Y(C.right) ? (0, b.separated)(i, (0, n.right)(C.right)) : (0, b.separated)((0, n.right)(C.right), i);
    };
    return {
      URI: n.URI,
      _E: void 0,
      map: v,
      compact: E,
      separate: U,
      filter: rn,
      filterMap: function(C, Y) {
        if ((0, n.isLeft)(C))
          return C;
        var nn = Y(C.right);
        return nn._tag === "None" ? i : (0, n.right)(nn.value);
      },
      partition: ut,
      partitionMap: function(C, Y) {
        if ((0, n.isLeft)(C))
          return (0, b.separated)(C, C);
        var nn = Y(C.right);
        return (0, n.isLeft)(nn) ? (0, b.separated)((0, n.right)(nn.left), i) : (0, b.separated)(i, (0, n.right)(nn.right));
      }
    };
  };
  n.getFilterable = a;
  var l = function(u) {
    var i = (0, n.getFilterable)(u), c = (0, n.getCompactable)(u);
    return {
      URI: n.URI,
      _E: void 0,
      map: v,
      compact: i.compact,
      separate: i.separate,
      filter: i.filter,
      filterMap: i.filterMap,
      partition: i.partition,
      partitionMap: i.partitionMap,
      traverse: H,
      sequence: n.sequence,
      reduce: V,
      foldMap: K,
      reduceRight: $,
      wither: (0, w.witherDefault)(n.Traversable, c),
      wilt: (0, w.wiltDefault)(n.Traversable, c)
    };
  };
  n.getWitherable = l;
  var y = function(u) {
    return {
      URI: n.URI,
      _E: void 0,
      map: v,
      ap: function(i, c) {
        return (0, n.isLeft)(i) ? (0, n.isLeft)(c) ? (0, n.left)(u.concat(i.left, c.left)) : i : (0, n.isLeft)(c) ? c : (0, n.right)(i.right(c.right));
      },
      of: n.of
    };
  };
  n.getApplicativeValidation = y;
  var N = function(u) {
    return {
      URI: n.URI,
      _E: void 0,
      map: v,
      alt: function(i, c) {
        if ((0, n.isRight)(i))
          return i;
        var E = c();
        return (0, n.isLeft)(E) ? (0, n.left)(u.concat(i.left, E.left)) : E;
      }
    };
  };
  n.getAltValidation = N;
  var P = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? i : (0, n.right)(u(i.right));
    };
  };
  n.map = P, n.Functor = {
    URI: n.URI,
    map: v
  }, n.of = n.right, n.Pointed = {
    URI: n.URI,
    of: n.of
  };
  var R = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? i : (0, n.isLeft)(u) ? u : (0, n.right)(i.right(u.right));
    };
  };
  n.apW = R, n.ap = n.apW, n.Apply = {
    URI: n.URI,
    map: v,
    ap: j
  }, n.Applicative = {
    URI: n.URI,
    map: v,
    ap: j,
    of: n.of
  };
  var x = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? i : u(i.right);
    };
  };
  n.chainW = x, n.chain = n.chainW, n.Chain = {
    URI: n.URI,
    map: v,
    ap: j,
    chain: B
  }, n.Monad = {
    URI: n.URI,
    map: v,
    ap: j,
    of: n.of,
    chain: B
  };
  var X = function(u, i) {
    return function(c) {
      return (0, n.isLeft)(c) ? u : i(u, c.right);
    };
  };
  n.reduce = X;
  var en = function(u) {
    return function(i) {
      return function(c) {
        return (0, n.isLeft)(c) ? u.empty : i(c.right);
      };
    };
  };
  n.foldMap = en;
  var Dn = function(u, i) {
    return function(c) {
      return (0, n.isLeft)(c) ? u : i(c.right, u);
    };
  };
  n.reduceRight = Dn, n.Foldable = {
    URI: n.URI,
    reduce: V,
    foldMap: K,
    reduceRight: $
  };
  var Fn = function(u) {
    return function(i) {
      return function(c) {
        return (0, n.isLeft)(c) ? u.of((0, n.left)(c.left)) : u.map(i(c.right), n.right);
      };
    };
  };
  n.traverse = Fn;
  var Un = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? u.of((0, n.left)(i.left)) : u.map(i.right, n.right);
    };
  };
  n.sequence = Un, n.Traversable = {
    URI: n.URI,
    map: v,
    reduce: V,
    foldMap: K,
    reduceRight: $,
    traverse: H,
    sequence: n.sequence
  };
  var jn = function(u, i) {
    return function(c) {
      return (0, n.isLeft)(c) ? (0, n.left)(u(c.left)) : (0, n.right)(i(c.right));
    };
  };
  n.bimap = jn;
  var Wn = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? (0, n.left)(u(i.left)) : i;
    };
  };
  n.mapLeft = Wn, n.Bifunctor = {
    URI: n.URI,
    bimap: d,
    mapLeft: g
  };
  var qn = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? u() : i;
    };
  };
  n.altW = qn, n.alt = n.altW, n.Alt = {
    URI: n.URI,
    map: v,
    alt: m
  };
  var Bn = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? i : (0, n.right)(u(i));
    };
  };
  n.extend = Bn, n.Extend = {
    URI: n.URI,
    map: v,
    extend: s
  }, n.ChainRec = {
    URI: n.URI,
    map: v,
    ap: j,
    chain: B,
    chainRec: L
  }, n.throwError = n.left, n.MonadThrow = {
    URI: n.URI,
    map: v,
    ap: j,
    of: n.of,
    chain: B,
    throwError: n.throwError
  }, n.FromEither = {
    URI: n.URI,
    fromEither: A.identity
  }, n.fromPredicate = (0, M.fromPredicate)(n.FromEither), n.fromOption = (0, M.fromOption)(n.FromEither), n.isLeft = S.isLeft, n.isRight = S.isRight;
  var Vn = function(u, i) {
    return function(c) {
      return (0, n.isLeft)(c) ? u(c.left) : i(c.right);
    };
  };
  n.matchW = Vn, n.foldW = n.matchW, n.match = n.matchW, n.fold = n.match;
  var Kn = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? u(i.left) : i.right;
    };
  };
  n.getOrElseW = Kn, n.getOrElse = n.getOrElseW, n.flap = (0, F.flap)(n.Functor), n.apFirst = (0, f.apFirst)(n.Apply), n.apFirstW = n.apFirst, n.apSecond = (0, f.apSecond)(n.Apply), n.apSecondW = n.apSecond, n.chainFirst = (0, h.chainFirst)(n.Chain), n.chainFirstW = n.chainFirst, n.flattenW = (0, n.chainW)(A.identity), n.flatten = n.flattenW, n.duplicate = (0, n.extend)(A.identity), n.fromOptionK = (0, M.fromOptionK)(n.FromEither), n.chainOptionK = (0, M.chainOptionK)(n.FromEither, n.Chain), n.filterOrElse = (0, M.filterOrElse)(n.FromEither, n.Chain), n.filterOrElseW = n.filterOrElse;
  var $n = function(u) {
    return (0, n.isLeft)(u) ? (0, n.right)(u.left) : (0, n.left)(u.right);
  };
  n.swap = $n;
  var Hn = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? u(i.left) : i;
    };
  };
  n.orElseW = Hn, n.orElse = n.orElseW;
  var Gn = function(u) {
    return function(i) {
      return i == null ? (0, n.left)(u) : (0, n.right)(i);
    };
  };
  n.fromNullable = Gn;
  var Jn = function(u, i) {
    try {
      return (0, n.right)(u());
    } catch (c) {
      return (0, n.left)(i(c));
    }
  };
  n.tryCatch = Jn;
  var zn = function(u, i) {
    return function() {
      for (var c = [], E = 0; E < arguments.length; E++)
        c[E] = arguments[E];
      return (0, n.tryCatch)(function() {
        return u.apply(void 0, c);
      }, i);
    };
  };
  n.tryCatchK = zn;
  var Xn = function(u) {
    var i = (0, n.fromNullable)(u);
    return function(c) {
      return (0, A.flow)(c, i);
    };
  };
  n.fromNullableK = Xn;
  var Yn = function(u) {
    var i = (0, n.fromNullableK)(u);
    return function(c) {
      return (0, n.chain)(i(c));
    };
  };
  n.chainNullableK = Yn, n.toUnion = (0, n.foldW)(A.identity, A.identity);
  function Zn(u) {
    return u instanceof Error ? u : new Error(String(u));
  }
  n.toError = Zn;
  function mn(u) {
    return function(i, c) {
      if (c === void 0) {
        var E = mn(u);
        return function(U) {
          return E(i, U);
        };
      }
      return (0, n.isLeft)(c) ? !1 : u.equals(i, c.right);
    };
  }
  n.elem = mn;
  var Qn = function(u) {
    return function(i) {
      return (0, n.isLeft)(i) ? !1 : u(i.right);
    };
  };
  n.exists = Qn, n.Do = (0, n.of)(S.emptyRecord), n.bindTo = (0, F.bindTo)(n.Functor), n.bind = (0, h.bind)(n.Chain), n.bindW = n.bind, n.apS = (0, f.apS)(n.Apply), n.apSW = n.apS, n.ApT = (0, n.of)(S.emptyReadonlyArray);
  var kn = function(u) {
    return function(i) {
      var c = u(0, S.head(i));
      if ((0, n.isLeft)(c))
        return c;
      for (var E = [c.right], U = 1; U < i.length; U++) {
        var rn = u(U, i[U]);
        if ((0, n.isLeft)(rn))
          return rn;
        E.push(rn.right);
      }
      return (0, n.right)(E);
    };
  };
  n.traverseReadonlyNonEmptyArrayWithIndex = kn;
  var xn = function(u) {
    var i = (0, n.traverseReadonlyNonEmptyArrayWithIndex)(u);
    return function(c) {
      return S.isNonEmpty(c) ? i(c) : n.ApT;
    };
  };
  n.traverseReadonlyArrayWithIndex = xn, n.traverseArrayWithIndex = n.traverseReadonlyArrayWithIndex;
  var nt = function(u) {
    return (0, n.traverseReadonlyArrayWithIndex)(function(i, c) {
      return u(c);
    });
  };
  n.traverseArray = nt, n.sequenceArray = (0, n.traverseArray)(A.identity);
  function tt(u, i) {
    return (0, n.tryCatch)(function() {
      return JSON.parse(u);
    }, i);
  }
  n.parseJSON = tt;
  var et = function(u, i) {
    return (0, n.tryCatch)(function() {
      var c = JSON.stringify(u);
      if (typeof c != "string")
        throw new Error("Converting unsupported structure to JSON");
      return c;
    }, i);
  };
  n.stringifyJSON = et, n.either = {
    URI: n.URI,
    map: v,
    of: n.of,
    ap: j,
    chain: B,
    reduce: V,
    foldMap: K,
    reduceRight: $,
    traverse: H,
    sequence: n.sequence,
    bimap: d,
    mapLeft: g,
    alt: m,
    extend: s,
    chainRec: L,
    throwError: n.throwError
  }, n.getApplySemigroup = (0, f.getApplySemigroup)(n.Apply), n.getApplyMonoid = (0, o.getApplicativeMonoid)(n.Applicative);
  var rt = function(u, i) {
    return (0, f.getApplySemigroup)((0, n.getApplicativeValidation)(u))(i);
  };
  n.getValidationSemigroup = rt;
  var it = function(u, i) {
    return (0, o.getApplicativeMonoid)((0, n.getApplicativeValidation)(u))(i);
  };
  n.getValidationMonoid = it;
  function at(u) {
    var i = (0, n.getApplicativeValidation)(u).ap, c = (0, n.getAltValidation)(u).alt;
    return {
      URI: n.URI,
      _E: void 0,
      map: v,
      of: n.of,
      chain: B,
      bimap: d,
      mapLeft: g,
      reduce: V,
      foldMap: K,
      reduceRight: $,
      extend: s,
      traverse: H,
      sequence: n.sequence,
      chainRec: L,
      throwError: n.throwError,
      ap: i,
      alt: c
    };
  }
  n.getValidation = at;
})(ln);
const Xe = {
  acceptAnonymous: !1
}, dn = {
  USER_ID_KEY: "ajs_user_id",
  ANONYMOUS_KEY: "ajs_anonymous_id",
  USER_TRAITS: "ajs_user_traits"
}, Qe = (n = Xe) => {
  const { acceptAnonymous: t } = n, e = JSON.parse(localStorage.getItem(dn.USER_ID_KEY)), r = JSON.parse(localStorage.getItem(dn.ANONYMOUS_KEY));
  return t ? e != null ? e : r : e;
}, Ye = () => un(
  JSON.parse(localStorage.getItem(dn.USER_TRAITS)),
  ln.fromNullable({}),
  ln.fold(yn, yn)
);
export {
  Ze as configure,
  Qe as getUserId,
  Ye as getUserTraits,
  dn as stores
};
